var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigliveForbiddenState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6459 48.8572C12.0148 48.8572 4.4324 56.5024 5.1961 65.4433L9.62675 117.007C10.3117 124.99 17.4698 131.143 26.0765 131.143H153.923C162.524 131.143 169.682 124.99 170.373 117.007L174.804 65.4433C175.573 56.5085 167.985 48.8572 158.354 48.8572H21.6459Z",
    fill: "#CCE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5208 99.8935C48.1367 99.8935 47.0049 98.8327 47.0049 97.5213V40.3006C47.0049 38.9956 48.1367 37.9285 49.5208 37.9285H78.1435C78.8185 37.9285 79.4731 38.192 79.9435 38.6485L87.7026 46.1763H133.166C134.55 46.1763 135.682 47.237 135.682 48.5485V97.5278C135.682 98.8328 134.55 99.8999 133.166 99.8999H49.514L49.5208 99.8935Z",
    fill: "#D3DEEE",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4707 136.761C43.8207 136.761 42.4707 135.495 42.4707 133.933V54.7329C42.4707 53.1772 43.8139 51.9043 45.4707 51.9043H78.9343C79.7389 51.9043 80.523 52.2193 81.0821 52.7657L90.1366 61.5472H143.257C144.907 61.5472 146.257 62.8136 146.257 64.3757V133.939C146.257 135.495 144.914 136.768 143.257 136.768H45.4707V136.761Z",
    fill: "#7A9CCB",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.625 107.749H102.982C102.059 107.749 101.312 108.454 101.312 109.324V126.707C101.312 127.577 102.059 128.282 102.982 128.282H134.625C135.548 128.282 136.296 127.577 136.296 126.707V109.324C136.296 108.454 135.548 107.749 134.625 107.749Z",
    fill: "#D3DEEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1119 111.386V97.9728C53.1119 93.7424 49.4698 90.298 44.9966 90.298C40.5234 90.298 36.8813 93.7424 36.8813 97.9728V111.386H30.4351V97.9792C30.4351 90.3875 36.9624 84.2144 44.9899 84.2144C53.0173 84.2144 59.5447 90.3875 59.5447 97.9792V111.393H53.0984L53.1119 111.386Z",
    fill: "white",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3557 109.897H30.6447C28.7826 109.897 27.2729 111.325 27.2729 113.086V140.168C27.2729 141.93 28.7826 143.357 30.6447 143.357H59.3557C61.2179 143.357 62.7275 141.93 62.7275 140.168V113.086C62.7275 111.325 61.2179 109.897 59.3557 109.897Z",
    fill: "white",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0035 134.072C43.9562 134.072 43.098 133.267 43.098 132.27V127.976L42.9224 127.886C41.4155 127.106 40.5371 125.547 40.6925 123.924C40.8817 121.93 42.6115 120.333 44.7265 120.211C44.8211 120.211 44.9089 120.205 45.0035 120.205C47.3888 120.205 49.3348 122.039 49.3348 124.301C49.3348 125.796 48.4699 127.17 47.0847 127.892L46.909 127.982V132.276C46.909 133.267 46.0576 134.078 45.0035 134.078V134.072Z",
    fill: "#7A9CCB",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4897 116.626C32.7667 116.626 32.1855 116.07 32.1855 115.387C32.1855 114.703 32.7734 114.153 33.4897 114.153C34.2059 114.153 34.7938 114.709 34.7938 115.387C34.7938 116.064 34.2059 116.626 33.4897 116.626Z",
    fill: "#7A9CCB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.518 116.626C55.795 116.626 55.2139 116.07 55.2139 115.387C55.2139 114.703 55.8017 114.153 56.518 114.153C57.2342 114.153 57.8221 114.709 57.8221 115.387C57.8221 116.064 57.2342 116.626 56.518 116.626Z",
    fill: "#7A9CCB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M137.53 82.9285C150.442 82.9285 160.909 73.0592 160.909 60.8849C160.909 48.7106 150.442 38.8413 137.53 38.8413C124.618 38.8413 114.15 48.7106 114.15 60.8849C114.15 73.0592 124.618 82.9285 137.53 82.9285Z",
    fill: "#0045A3"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M135.198 80.73C148.11 80.73 158.577 70.8607 158.577 58.6864C158.577 46.5121 148.11 36.6428 135.198 36.6428C122.286 36.6428 111.818 46.5121 111.818 58.6864C111.818 70.8607 122.286 80.73 135.198 80.73Z",
    fill: "#3378D6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.139 49.005C144.007 47.9443 142.159 47.9443 141.027 49.005L135.327 54.3472L129.627 49.005C128.495 47.9443 126.648 47.9443 125.516 49.005C124.384 50.0657 124.384 51.8014 125.516 52.8622L131.216 58.2043L125.516 63.5464C124.384 64.6071 124.384 66.3429 125.516 67.4036C126.648 68.4643 128.495 68.4643 129.627 67.4036L135.327 62.0614L141.027 67.4036C142.159 68.4643 144.007 68.4643 145.139 67.4036C146.27 66.3429 146.27 64.6071 145.139 63.5464L139.439 58.2043L145.139 52.8622C146.27 51.8014 146.27 50.0657 145.139 49.005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigliveForbiddenState);
export default __webpack_public_path__ + "static/media/siglive-forbidden-state.81ef051759b7010f1ed31da92f68fb4e.svg";
export { ForwardRef as ReactComponent };